import { useState } from 'react'
import { Input, Select } from '../../components/forms'
import Button from '../../components/ui/Button'
import { formatDateInput } from '../../lib/format'

const FREQUENCY_OPTIONS = [
  { value: 'monthly', label: 'Monthly' },
  { value: 'quarterly', label: 'Quarterly' },
  { value: 'yearly', label: 'Yearly' },
]

const CATEGORY_OPTIONS = [
  { value: 'software', label: 'Software & Tools' },
  { value: 'marketing', label: 'Marketing' },
  { value: 'hosting', label: 'Hosting & Infrastructure' },
  { value: 'services', label: 'Professional Services' },
  { value: 'supplies', label: 'Office Supplies' },
  { value: 'salary', label: 'Salary & Wages' },
  { value: 'other', label: 'Other' },
]

function SubscriptionForm({
  initialData,
  businesses = [],
  onSubmit,
  onCancel,
  loading = false,
}) {
  const [formData, setFormData] = useState({
    name: initialData?.name || '',
    amount: initialData?.amount || '',
    frequency: initialData?.frequency || 'monthly',
    category: initialData?.category || 'software',
    business_id: initialData?.business_id || '',
    is_active: initialData?.is_active ?? true,
    next_billing_date: formatDateInput(initialData?.next_billing_date || ''),
    notes: initialData?.notes || '',
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit({
      ...formData,
      amount: parseFloat(formData.amount),
      business_id: formData.business_id || null,
      is_active: formData.is_active === true || formData.is_active === 'true',
      next_billing_date: formData.next_billing_date || null,
    })
  }

  const businessOptions = [
    { value: '', label: 'Second Shift Ventures All' },
    ...businesses.map(b => ({
      value: b.id,
      label: `${b.emoji} ${b.name}`,
    })),
  ]

  return (
    <form onSubmit={handleSubmit}>
      <Input
        label="Subscription Name"
        name="name"
        value={formData.name}
        onChange={handleChange}
        placeholder="e.g., AWS, Slack, GitHub"
        required
      />

      <div className="grid grid-2">
        <Input
          label="Amount"
          name="amount"
          type="number"
          step="0.01"
          min="0"
          value={formData.amount}
          onChange={handleChange}
          placeholder="0.00"
          required
        />
        <Select
          label="Frequency"
          name="frequency"
          value={formData.frequency}
          onChange={handleChange}
          options={FREQUENCY_OPTIONS}
        />
      </div>

      <div className="grid grid-2">
        <Select
          label="Category"
          name="category"
          value={formData.category}
          onChange={handleChange}
          options={CATEGORY_OPTIONS}
          required
        />
        <Select
          label="Business"
          name="business_id"
          value={formData.business_id}
          onChange={handleChange}
          options={businessOptions}
        />
      </div>

      <div className="grid grid-2">
        <Select
          label="Status"
          name="is_active"
          value={formData.is_active.toString()}
          onChange={(e) => setFormData(prev => ({
            ...prev,
            is_active: e.target.value === 'true'
          }))}
          options={[
            { value: 'true', label: 'Active' },
            { value: 'false', label: 'Paused' },
          ]}
        />
        <Input
          label="Next Billing Date"
          name="next_billing_date"
          type="date"
          value={formData.next_billing_date}
          onChange={handleChange}
        />
      </div>

      <Input
        label="Notes (optional)"
        name="notes"
        value={formData.notes}
        onChange={handleChange}
        placeholder="Any additional notes..."
      />

      <div className="flex justify-between gap-3 mt-6">
        <Button type="button" variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit" variant="primary" loading={loading}>
          {initialData ? 'Update' : 'Add'} Subscription
        </Button>
      </div>
    </form>
  )
}

export default SubscriptionForm
